import React, { useEffect, useState, useContext } from "react";
import {
  Grid,
  Button,
  Card,
  CardContent,
  Typography,
  CardMedia,
  TextField,
  CircularProgress,
  createMuiTheme,
  ThemeProvider,
  Avatar,
} from "@material-ui/core";
import Autocomplete, {
  createFilterOptions,
} from "@material-ui/lab/Autocomplete";
import { Context } from "../store";
import { get_Providers, modify_AppointmentDetails } from "../actions";
import { useHistory } from "react-router-dom";
import { Provider } from "../store/index";
import useStyles from "../css/styles";
import { InsertPELogs } from '../api'; //FB 4960
import globalsettings from "../../../config"; //FB 4960

// update log
// FB 4371 DK   03/29/2021    Added for Provider module in home page
// FB 4371 DK   04/20/2021    Fixed image src issue
// FB 4574 DK   07/15/2021    Added styling for dropdown icon
// FB 4769 MS   11/02/2021    Added Job title for provider
// FB 4794 MS   11/08/2021    Removed the wrongly added comment
// FB 4960 BR    07/03/2022   Logging all actions on PE
// FB 7801 SK    12/14/2023   PE - Handling Appointment Types that have Differing Lengths of Time
// FB 7999 MS    01/05/2024   select provider by default in case of single provider practice
// FB 8097 DK    01/17/2024   Single provider workflow is not working

export default function ProviderComponent(props: any) {
  const [open, setOpen] = React.useState(false);
  const { state, dispatch } = useContext(Context);
  const [providers, setProviders] = React.useState<Provider[]>([]);
  const loading = open && providers.length === 0;
  const styles = useStyles();

  const theme = createMuiTheme({
    palette: {
      primary: {
        main: "#18a2b8",
      },
      action: {
        selected: "#8BD0DB",
        hover: "#5DBDCD",
      },
    },
  });

  //FB 4371 DK    Added to load the provider list
  useEffect(() => {
    //if (!state.providers || state.providers.length === 0) {
    //FB 4371 DK - Added new param to send the selected appointment type
    get_Providers(
      state.appointmentdetails.insurance.id,
      state.appointmentdetails.appointmenttype,
      dispatch
    ).then(() => {
      setProviders(state.providers);
    });
    //}
  }, []);

  //FB 7999 BEGIN
  //FB 8097 Start
  useEffect(() => {
    if (state.providers.length == 1) {
      SetSelectedProvider(state.providers[0]);
      modify_AppointmentDetails(
        {
          appointmenttype: state.appointmentdetails.appointmenttype,
          customappointmenttype: state.appointmentdetails.customappointmenttype,
          patientType: state.appointmentdetails.patientType,
          isInsuranceExist: state.appointmentdetails.isInsuranceExist,
          insurance: {
            id: state.appointmentdetails.insurance.id,
            planId: state.appointmentdetails.insurance.planId,
            name: state.appointmentdetails.insurance.name,
            planName: state.appointmentdetails.insurance.planName,
          },
          appointmentfilter: state.appointmentdetails.appointmentfilter,
          provider: state.providers[0],
          location: {
            id: 0,
            name: "",
            address: "",
            region: 0,
          },
          date: new Date(),
        },
        dispatch
      );
    }
  }, [state.providers.length > 0]);
  //FB 8097 End
  //FB 7999 END

  useEffect(() => {
    let active = true;

    if (!loading) {
      return undefined;
    }

    if (active) {
      setProviders(state.providers);
    }

    return () => {
      active = false;
    };
  }, [loading, state.providers.length]);

  const [selectedprovider, SetSelectedProvider] = useState<Provider>({
    name: state.appointmentdetails.provider.name,
    id: state.appointmentdetails.provider.id,
    bio: state.appointmentdetails.provider.bio,
    job_title: state.appointmentdetails.provider.job_title,  //FB 4769
  });

  useEffect(() => {
    if (!open) {
      setProviders([]);
    }
  }, [open]);

  //FB 4371 DK    Added to modify the state when provider is selected
  const handleChange = (event: any, value: any) => {
    if (value != null) {
      SetSelectedProvider(value as Provider);
      //FB 4960 Start
      InsertPELogs(globalsettings.clientIp, "Choose the provider " + value.name);
      //FB 4960 End
      modify_AppointmentDetails(
        {
          appointmenttype: state.appointmentdetails.appointmenttype,
          customappointmenttype: state.appointmentdetails.customappointmenttype,//FB 7801
          patientType: state.appointmentdetails.patientType,
          isInsuranceExist: state.appointmentdetails.isInsuranceExist,
          insurance: {
            id: state.appointmentdetails.insurance.id,
            planId: state.appointmentdetails.insurance.planId,
            name: state.appointmentdetails.insurance.name,
            planName: state.appointmentdetails.insurance.planName,
          },
          appointmentfilter: state.appointmentdetails.appointmentfilter,
          provider: {
            id: value.id,
            name: value.name,
            bio: value.bio,
            job_title: value.job_title, //FB 4769
          },
          location: {
            id: 0,
            name: "",
            address: "",
            region: 0,
          },
          date: new Date(),
        },
        dispatch
      );
    } else {
      SetSelectedProvider({
        name: "",
        id: 0,
        bio: "",
        job_title: "", //FB 4769
      });
    }
  };

  const handleGoback = () => {
    //FB 4960 Start
    InsertPELogs(globalsettings.clientIp, "Clicked on Go Back - by provider");
    //FB 4960 End
    props.onCallbackType("");
  };

  const history = useHistory();

  //FB 4371 DK    Added to navigate to slots page

  const handleProceed = () => {
    //FB 4960 Start
    InsertPELogs(globalsettings.clientIp, "Clicked on Show Schedule - by provider");
    //FB 4960 End
    history.push("/slots_byprovider", state);
  };

  const scrollTo = (ref: any) => {
    if (ref /* + other conditions */) {
      ref.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <div ref={scrollTo}>
      <Grid container spacing={2}>
        <Grid
          item
          xs={12}
          sm={6}
          md={5}
          style={{ display: "flex", alignItems: "flex-end" }}
        >
          <Typography variant="h6">Please choose the provider</Typography>
        </Grid>
        {/* FB 4794 */}
        <Grid item xs={12} sm={6} md={6} lg={4}>
          <ThemeProvider theme={theme}>
            <Autocomplete
              id="providerlist"
              className={styles.dropdown_nomargin}
              fullWidth
              //style={{ width: "-webkit-fill-available" }}
              onChange={handleChange}
              open={open}
              value={{
                name: selectedprovider.name,
                id: selectedprovider.id,
                bio: selectedprovider.bio,
                job_title: selectedprovider.job_title,  //FB 4769
              }}
              onOpen={() => {
                setOpen(true);
              }}
              onClose={() => {
                setOpen(false);
              }}
              //getOptionSelected={(option, value) => option === value}
              getOptionLabel={(option) => option.job_title != "" && option.job_title != undefined ? option.name + " (" + option.job_title + ")" : option.name} //FB 4769
              groupBy={(option) =>
                option.InsuranceAcceptance ? option.InsuranceAcceptance : ""
              }
              options={providers}
              loading={loading}
              //filterOptions={filterOptions}
              ListboxProps={{
                style: {
                  maxHeight: 200,
                },
              }}
              //FB 4574 DK - Added styling for dropdown icon
              classes={{
                popupIndicator: styles.autocompleteIcon
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Provider"
                  id="provider"
                  variant="standard"
                  margin="normal"
                  InputProps={{
                    style: { borderColor: "red" },
                    ...params.InputProps,
                    endAdornment: (
                      <React.Fragment>
                        {loading ? (
                          <CircularProgress color="inherit" size={20} />
                        ) : null}
                        {params.InputProps.endAdornment}
                      </React.Fragment>
                    ),
                  }}
                />
              )}
            />
          </ThemeProvider>
        </Grid>
      </Grid>
      <Grid
        container
        spacing={2}
        style={{
          display: selectedprovider.id > 0 ? "flex" : "none",
        }}
      >
        <Grid item xs={12} sm={6} md={5}></Grid>
        <Grid
          item
          xs={12}
          sm={6}
          md={5}
          lg={5}
          style={{
            display: "flex",
            justifyContent: window.innerWidth <= 768 ? "center" : "",
          }}
        >
          <Card className={styles.provider_Card}>
            <CardMedia style={{ display: "flex", justifyContent: "center" }}>
              {/* FB 4371 DK - Changes the src syntax */}
              <Avatar
                style={{ margin: 5 }}
                className={styles.card_Avatar}
                src={`/Images/Providers/${selectedprovider.id}.jpg`}
              />
            </CardMedia>
            <CardContent>
              <Typography variant="h6">
                <b>{selectedprovider.name}</b>
              </Typography>
              {/* FB 4769 BEGIN */}
              <Typography style={{ fontSize: "smaller" }}>
                {selectedprovider.job_title}
              </Typography>
              {/* FB 4769 END */}
              <Typography style={{ fontSize: "smaller" }}>
                {selectedprovider.bio}
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
      <Grid container spacing={3} className={styles.flexend_Grid}>
        <Grid
          item
          xs={6}
          sm={4}
          md={3}
          lg={2}
          style={{
            display: selectedprovider.id > 0 ? "block" : "none",
          }}
        >
          <Button
            variant="contained"
            className={styles.navigationButton}
            onClick={handleProceed}
          >
            Show Schedule
          </Button>
        </Grid>
        <Grid item xs={6} sm={4} md={2} lg={2} className={styles.flexend_Grid}>
          <Button
            id="goBackProvider"
            onClick={handleGoback}
            variant="contained"
            className={styles.navigationButton}
          >
            Go Back
          </Button>
        </Grid>
      </Grid>
    </div>
  );
}
